(function() {
    'use strict';

    angular.module('dashboardApp').service('Routing', Service);

    Service.$inject = [
        '$location',
        '$window'
    ];


    function Service(
        $location,
        $window
    ) {


        this.start = function () {
            $location.path('/start').replace();
        };



        this.login = function () {
            $location.path('/login').replace();
        };



        this.apps = function () {
            $location.path('/apps').replace();
        };


        this.oAuthDispatcher = function () {
            var redirectUrl = $location.$$protocol + '://' + $location.$$host + '/oauth-dispatcher/api/OAuth/Login';
            $window.location = redirectUrl;
        };



    }

})();
